import template from './kdatatable.html';
import controller from './kdatatable.controller';

import './kdatatable.scss';
import 'tabulator-tables/dist/css/bootstrap/tabulator_bootstrap.min.css';

export default {
	template,
	bindings: {
		table: '=',

		columns: '<',
		data: '<',
		options: '<',

		isLoading: '<',

		bordered: '<?',
		rounded:  '<?',

		onBuilding: '&?',
		onDataLoaded: '&?',
		onReady: '&?',
	},
	transclude: {
		header: '?tableHeader',
		footer: '?tableFooter',
	},
	controller,
};
